import { axiosPost, axiosGet } from "../react_axios/Axios"
import {
    platform, headers, insertUserRegistrationUrl, INSERT_USER_REGISTRATION, GET_SSR_COUNTRY, getExhibitionSSRCountryMappingDataUrl,
} from "../utils/constants"


export const insertUserRegistration_action = (USRCompanyName, FirstName, Designation, LastName, Email, MobileNo, USRCountryID, RoleID) => async (dispatch) => {
    try {
        const param = {
            USRCompanyName: USRCompanyName,
            FirstName: FirstName,
            LastName: LastName,
            Email: Email,
            MobileNo: MobileNo,
            USRCountryID: USRCountryID,
            RoleID: RoleID,
            Designation: Designation,
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
        }

        const res = await axiosPost(insertUserRegistrationUrl, param);
        dispatch({
            type: INSERT_USER_REGISTRATION,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const getExhibitionSSRCountryMappingData_action = (ExhibitionCode) => async (dispatch) => {
    try {
        const mapdata = {
            ExhibitionCode: ExhibitionCode,
            //   ExhibitionID: ExhibitionID,
        }

        const res = await axiosGet(getExhibitionSSRCountryMappingDataUrl, mapdata, headers);
        dispatch({
            type: GET_SSR_COUNTRY,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};